export const actionTypes = {
  setFromInfo: "setFromInfo",
  setformData: "setformData",
  setformDataArray: "setformDataArray",
  setsearchformdata: "setsearchformdata",
};
const initstate = {
  model: {},
  formData:{},
  formDataArray:[],
  searchformdata:{},
};
export const FromInfoReducer = (state = initstate, action) => {
 
 
  switch (action.type) {
    case actionTypes.setFromInfo:
      return { ...state, model: action.payload };
      case actionTypes.setformData:
        return { ...state, formData: action.payload };
        case actionTypes.setsearchformdata:
          return { ...state, searchformdata: action.payload };
          case actionTypes.setformDataArray:
            return { ...state, formDataArray: action.payload };
    default:
      return state;
  }
};
export const FromInfoActions = {
  
  setFromInfo: (FromInfo) => ({ type: actionTypes.setFromInfo, payload: FromInfo }),
  setformData: (formData) => ({ type: actionTypes.setformData, payload: formData }),
  setformDataArray: (formDataArray) => ({ type: actionTypes.setformDataArray, payload: formDataArray }),
  setsearchformdata: (searchformdata) => ({ type: actionTypes.setsearchformdata, payload: searchformdata }),

};